
import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

const timeToFloat = (duration = '00:00') => {
  const isNumber = typeof duration === 'number' && !isNaN(duration)
  const isInteger = isNumber && Number.isInteger(duration)
  const isFloat = isNumber && !isInteger

  if (isInteger) {
    return duration
  } else if (isFloat) {
    return duration
  } else if (typeof duration === 'string') {
    const explodedDuration = duration.split(':')
    if (parseFloat(explodedDuration[1]) === 0) {
      return parseInt(explodedDuration[0])
    } else {
      return parseFloat(explodedDuration[0] + '.' + explodedDuration[1]).toFixed(2)
    }
  } else {
    return 0
  }
}

const formatDuration = (duration, short = false) => {
  if (duration !== null) {
    const explodedDuration = duration.split(':')

    const hour = parseInt(explodedDuration[0])
    const minute = parseFloat(explodedDuration[1])

    let selectedDurationFmt = ''

    if (hour > 0 && minute === 0) {
      selectedDurationFmt = hour + (hour === 1 ? ' hora' : ' horas')
    } else if (hour === 0 && minute > 0) {
      if (short) {
        selectedDurationFmt = minute + (minute === 1 ? ' min' : ' min')
      } else {
        selectedDurationFmt = minute + (minute === 1 ? ' minuto' : ' minutos')
      }
    } else if (hour === 0 && minute === 0) {
      selectedDurationFmt = hour + ' horas'
    } else {
      if (short) {
        selectedDurationFmt = `${hour}h ${minute}m`
      } else {
        selectedDurationFmt = hour + (hour === 1 ? ' hora e ' : ' horas e ') + minute + (minute === 1 ? ' minuto' : ' minutos')
      }
    }

    return selectedDurationFmt
  } else {
    return ''
  }
}

/*
const formatFloatToScaleDuration = (duration) => {
  const fmtDuration = valueToTime(duration || 0)
  return formatDuration(fmtDuration, true)
}
*/

const valueToTime = (duration = 0, withSeconds = false) => {
  const isNumber = typeof duration === 'number' && !isNaN(duration)
  const isInteger = isNumber && Number.isInteger(duration)
  const isFloat = isNumber && !isInteger

  if (duration === 24 || duration === '24') {
    return withSeconds ? '24:00:00' : '24:00'
  }

  if (isInteger) {
    if (withSeconds) {
      return (duration < 10) ? ('0' + duration + ':00:00') : (duration + ':00:00')
    } else {
      return (duration < 10) ? ('0' + duration + ':00') : (duration + ':00')
    }
  } else if (isFloat) {
    if (withSeconds) {
      return moment(duration, 'HHmm').format('HH:mm:ss')
    } else {
      return moment(duration, 'HHmm').format('HH:mm')
    }
  } else if (typeof duration === 'string') {
    if (withSeconds) {
      return moment(duration, 'HH:mm').format('HH:mm:ss')
    } else {
      return moment(duration, 'HH:mm').format('HH:mm')
    }
  } else {
    return duration
  }
}

const valueToDB = (duration = 0) => {
  const isNumber = typeof duration === 'number' && !isNaN(duration)
  const isInteger = isNumber && Number.isInteger(duration)
  const isFloat = isNumber && !isInteger

  if (isInteger) {
    return duration
  } else if (isFloat) {
    return moment(duration, 'HHmm').format('HH:mm')
  } else if (typeof duration === 'string') {
    return moment(duration, 'HH:mm').format('HH:mm')
  } else {
    return duration
  }
}

export {
  timeToFloat,
  formatDuration,
  valueToTime,
  valueToDB,
}
